import { useQuery } from "@apollo/client"
import { ReportData, ReportOptions, ReportType } from ".."
import { dataPlanToReportData } from "../reports-helpers"
import { getDataPlanReport, GetDataPlanReportQuery } from "../graphql/queries/getDataPlanReport"

export const useDataPlanReport = (options: ReportType<ReportOptions, "dataplan">) => {
  const { data, loading } = useQuery<GetDataPlanReportQuery>(getDataPlanReport(options.sharedPlan), {
    variables: {
      id: options.apiPlanId,
      resolution: options.resolution,
      fromTimestamp: options.fromTimestamp,
      toTimestamp: options.toTimestamp,
    },
  })

  return {
    data: (data && dataPlanToReportData(data.dataPlan)) as ReportType<ReportData, "dataplan"> | undefined,
    loading,
  }
}
